import { TextField } from "@mui/material";
import { useState } from "react";
import toList from "../utils/ComponentUtil";


function ProofReadingContent({ item, editContent, onSave }) {
    const [value, setValue] = useState(item.content);
    const [isEditMode, setIsEditMode] = useState(false);

    const handleChange = (e) => { setValue(e.target.value); };
    return (
        !isEditMode ?
            <>
                <div>{item.content}</div>
                <div className="edit-content-btn-wrp hbw-button-wrp">
                    <div className="edit-content-btn hbw-button" onClick={() => { setIsEditMode(true); }}>Edit This Content</div>
                </div>
            </> :
            <>
                <div className="editable-content-title">{editContent.title}</div>
                <div className="editable-content-subtitle">{editContent.subtitle}</div>
                <TextField id="outlined-multiline-flexible" className="editable-content-area"
                    label="Multiline"
                    multiline
                    value={value}
                    rows={10}
                    hiddenLabel={true}
                    InputLabelProps={{ shrink: false }}
                    onChange={handleChange}
                />
                <div className="validation-errors-wrp">
                    {toList(editContent.validations, undefined, (item) => {
                        return <div>{item}</div>
                    })}
                </div>
                <div className="success-wrp">{editContent.successMsg}</div>
                <div className="save-content-btn-wrp">
                    <div className="save-content-btn hbw-button" onClick={() => { onSave(value); setIsEditMode(false); }}>Submit</div>
                </div>
            </>
    );
};
export default ProofReadingContent;
